import BaseParser from './BaseParser';
import Quantity from './Quantity';
import _get from 'lodash/get';
import { BaseParserOptions, RangeOptions } from './SharedTypes';

class Range extends BaseParser {
  private quantityParser: Quantity;
  /**
   * @param {Quantity} options.range.quantityParser - Parser used for bounds of the range
   */
  constructor(options: BaseParserOptions = {}) {
    super();

    const rangeOptions = _get<BaseParserOptions, 'range', RangeOptions>(
      options,
      'range',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    this.quantityParser = _get<RangeOptions, 'quantityParser', Quantity>(
      rangeOptions,
      'quantityParser',
      new Quantity(),
    );
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Range) {
    if (!fhirProperty) return null;

    const low = _get<fhir.Range, 'low', fhir.Quantity>(
      fhirProperty,
      'low',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    const high = _get<fhir.Range, 'high', fhir.Quantity>(
      fhirProperty,
      'high',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    const lowDisplay = this.quantityParser.getDisplayValue(low) || 'N/A';
    const highDisplay = this.quantityParser.getDisplayValue(high) || 'N/A';

    return `${lowDisplay} - ${highDisplay}`;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getSortValue(fhirProperty: fhir.Range) {
    if (!fhirProperty) return null;

    const low = _get<fhir.Range, 'low', fhir.Quantity>(
      fhirProperty,
      'low',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    const lowSortValue = this.quantityParser.getSortValue(low);

    if (lowSortValue !== null) return lowSortValue;

    const high = _get<fhir.Range, 'high', fhir.Quantity>(
      fhirProperty,
      'high',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    return this.quantityParser.getSortValue(high);
  }
}

export default Range;
